import { toCSSPixel } from '../../../utils/styles'
import { Checkbox, CHECKBOX_SIZE, CHECKBOX_TYPE } from '../../Checkbox'
import { EmailImportantButton } from '../EmailImportantButton'

import * as styles from './EmailTableRowActions.module.css'

function EmailTableRowActions({
  ImportantButton = EmailImportantButton,
  className = styles.EmailTableRowActions,
  disabledCheckbox,
  disabledImportant,
  important,
  selected,
  width,
  onSelect,
  onSetImportant,
}) {
  return (
    <div className={className} style={{ width: toCSSPixel(width) }}>
      <Checkbox
        disabled={disabledCheckbox}
        selected={selected}
        size={CHECKBOX_SIZE.small}
        type={CHECKBOX_TYPE.tableRow}
        onChange={onSelect}
      />
      {ImportantButton ? (
        <ImportantButton
          disabled={disabledImportant}
          important={important}
          onSetImportant={onSetImportant}
        />
      ) : null}
    </div>
  )
}

export default EmailTableRowActions
